import { mutatorAction } from "satcheljs";
import { UserStore } from "sh-stores";

export default mutatorAction('SET_DISABLE_AVAILABILITY_TOGGLE', function setDisableHideScheduleAvailabilityToggle(disableHideScheduleAvailabilityToggle: boolean) {
    UserStore().disableHideScheduleAvailabilityToggle = disableHideScheduleAvailabilityToggle;
});
